import type { ReactNode } from 'react'
import type { BaseProps } from '@/frontend/features/Fde/types'

interface Props {
  props: BaseProps
  primaryLabel: string
  refreshProps?: string[]
  allowWithoutProject?: boolean
  renderPrimary: (headerActions: ReactNode) => ReactNode
}

export default function ForgeStage({ props, allowWithoutProject = false, renderPrimary }: Props) {
  if (!props.project && !allowWithoutProject) {
    return <div className="flex h-full items-center justify-center p-8 text-center">
      <p className="max-w-md text-sm text-muted-foreground">{props.copy.workspace.new_project_prompt}</p>
    </div>
  }
  return <div data-testid="fde-workspace-stage" className="h-full min-h-0 overflow-hidden bg-background">
    {renderPrimary(null)}
  </div>
}
